<script lang="ts">
	import CallToAction from '$src/lib/components/marketing/CallToAction.svelte'
	import Faq from '$src/lib/components/marketing/FAQ.svelte'
	import Hero from '$src/lib/components/marketing/Hero.svelte'
	import Pricing from '$src/lib/components/marketing/Pricing.svelte'
	import PrimaryFeatures from '$src/lib/components/marketing/PrimaryFeatures.svelte'
	import SecondaryFeatures from '$src/lib/components/marketing/SecondaryFeatures.svelte'
	import type { PageData } from './$types'
	import SvelteSeo from 'svelte-seo'

	interface Props {
		data: PageData
	}

	let { data }: Props = $props()

	// $: tipsData = data.tipsData
	let title = $derived(data?.title)
	let description = $derived(data?.description)

	let images = $derived([
		{
			url: `https://airheart.com/airheart-social.png`,
			width: 1200,
			height: 600,
			alt: title,
		},
	])
</script>

<SvelteSeo
	twitter={{
		description,
		title,
		image: `https://airheart.com/airheart-social.png`,
		imageAlt: title,
		site: '@airheartinc',
		card: 'summary_large_image',
	}}
	openGraph={{
		title,
		images,
		description,
	}}
/>

<Hero />
<PrimaryFeatures />
<SecondaryFeatures />
<CallToAction />
<Faq />
<Pricing />
